<template>
  <div>
    <h2 class="mb-3">
      {{ $t("exportPrompt.pdfOptions") }}
    </h2>
    <div class="mb-3">
      <div
          v-if="logId"
           @click="reportMode"
           :class="['settings-button d-inline-block mr-1', pdfGenerating ? 'disabled' : '']">
        Report <icon type="angle-right" />
      </div>
      <div
          @click="normalMode"
          :class="['settings-button d-inline-block mr-1 mixed-case', pdfGenerating ? 'disabled' : '']">
        vFORM <icon type="angle-right" />
      </div>
      <info-helper class="ml-1" text="Report: Filled out form, vForm: Empty form" />
      <session-user-selector
          v-if="showSessionSelection && !pdfGenerating && !pdfReportGenerating"
          class="pb-2 mt-3"
          :log-id="logId"
          @setSessionData="(data) => {startPDFReport(data)}"
      />
      <div class="mt-2" v-if="showNormalMode">
        <image-quality-selector v-model="imageQuality" />
        <div v-if="!pdfGenerating && !pdfReportGenerating" @click="exportToPDF" class="settings-button d-inline-block mt-2">
          {{ $t('start') }}
        </div>
      </div>
    </div>
    <div v-if="finishedMessage" class="form-error p-1 w-100 mt-1">
      {{ finishedMessage }}
    </div>
  </div>
</template>

<script>
import InfoHelper from "@/components/InfoHelper.vue";
import Icon from "@/components/Icon.vue";
import SessionUserSelector from "@/components/vForm/logs/SessionUserSelector.vue";
import ElementMethodMixinJs from "@/components/vForm/mixins/ElementMethodMixin.js.vue";
import toPDFMixinJs from "@/components/vForm/mixins/toPDFMixin.js.vue";
import vFormAndProjectMixin from "@/components/vForm/mixins/vFormAndProjectMixin.js.vue";
import {mapActions, mapState} from "vuex";
import {PlainLanguages} from "@/enum";
import ImageQualitySelector from './ImageQualitySelector.vue';
import {DEFAULT_EXPORT_IMAGE_QUALITY} from './exportImageQuality';
export default {
  name: "PDFExport",
  components: {SessionUserSelector, Icon, InfoHelper, ImageQualitySelector},
  mixins: [ElementMethodMixinJs, toPDFMixinJs, vFormAndProjectMixin],
  props: {
    logId: {type: String, default: null},
    config: {type: Object, required: true},
    organizationId: {type: String, required: true},
    projectId: {type: String, required: true},
    formId: {type: String, required: true},
    slides: {type: Array, required: true},
    projectLoadingMode: {type: String, required: true},
  },
  data() {
    return {
      showSessionSelection: false,
      showNormalMode: false,
      pdfReportGenerating: false,
      finishedMessage: '',
      imageQuality: DEFAULT_EXPORT_IMAGE_QUALITY,
      PlainLanguages
    }
  },
  computed: {
    ...mapState({
      pdfGenerating: state => state.formpage.isPDFGenerating,
    }),
  },
  beforeMount() {
    this.updatePDFGenerating(false);
    this.finishedMessage = '';
  },
  methods: {
    ...mapActions([
      "updateCurrentPDFPage",
      "updateTotalPDFPages",
      "updatePDFGenerating",
    ]),
    async startPDFReport(config) {
      this.finishedMessage = "";
      await this.updatePDFGenerating(true)
      try {
        await this.toPDF(this.organizationId, this.projectId, this.formId, this.slides, this.config, this.projectLoadingMode, {
          ...config,
          isFormRTL: this.currentLanguageDir() === 'rtl',
        });
      } catch (error) {
        this.finishedMessage = this.$t('exportPrompt.exportFailed');
      } finally {
        await this.updatePDFGenerating(false);
      }
    },
    setPDFTotalPages(pageNo) {
      this.updateTotalPDFPages(pageNo);
    },
    setPDFAddingPage(pageNo) {
      this.updateCurrentPDFPage(pageNo);
    },
    setPDFGenerating(bool) {
      this.pdfGenerating = bool;
    },
    setPdfReportGenerating(bool) {
      this.pdfReportGenerating = bool;
    },
    currentLanguageDir() {
      const language = this.$store.getters.getSelectedFormLanguage;
      const languageObject = Object.values(this.PlainLanguages).find(lang => lang.name === language);
      return languageObject && languageObject.dir ? languageObject.dir : 'ltr';
    },
    async exportToPDF() {
      this.finishedMessage = "";
      await this.updatePDFGenerating(true)
      const isFormRTL = this.currentLanguageDir() === 'rtl';
      console.log('isFormRTL', isFormRTL);
      try {
        await this.toPDF(this.organizationId, this.projectId, this.formId, this.slides, this.config, this.projectLoadingMode, {
          imageQuality: this.imageQuality,
          isFormRTL
        });
        this.finishedMessage = "The PDF has been saved into your downloads folder.";
      } catch (error) {
        this.finishedMessage = this.$t('exportPrompt.exportFailed');
      } finally {
        await this.updatePDFGenerating(false);
      }
    },
    normalMode() {
      this.showSessionSelection = false;
      this.showNormalMode = true;
      this.finishedMessage = "";
    },
    reportMode() {
      this.showSessionSelection = true;
      this.showNormalMode = false;
      this.finishedMessage = "";
    },
  }
}
</script>
